import { ProdutoPacote } from './produto-pacote.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProdutoPacoteService {

    constructor(private http: Http){}

    getProdutoPacote(): Observable<ProdutoPacote[]> {
        return this.http.get(`${NTECH_API}/produto-pacote`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/produto-pacote/produto-pacote.service.ts